import {Component, EventEmitter, Input, Output, OnInit} from '@angular/core';
import {formatDate} from '@angular/common';

@Component({
    selector: 'app-datepicker',
    templateUrl: './datepicker.component.html',
    styleUrls: ['./datepicker.component.scss'],
})
export class DatepickerComponent implements OnInit {
  @Input() name: string;
  @Input() date = null;
  @Input() locale = 'en';
  @Output() dateChange = new EventEmitter<string>();
  @Input() disabled: boolean;
  @Output() ngModelChange = new EventEmitter<unknown>();

  initValue = null;

  constructor() {
  }

  ngOnInit() {
    this.initValue = this.date
  }

  datePick(event) {
    if (this.date && this.date !== this.initValue) {
      const myDate = this.date.substring(0, 10);
      this.initValue = myDate;
      this.dateChange.emit(myDate);
      this.ngModelChange.emit(myDate);
    }
  }

  format(myDate) {
    if (!myDate) {
      return '';
    }
    const format = 'dd/MM/yyyy';
    const locale = 'en-US';
    const formattedDate = formatDate(myDate, format, locale);
    return formattedDate;
  }
}
